<template>
	<div class="content-box">
		<el-form
			class="row"
			ref="editorForm"
			:model="form"
			:rules="rules"
			status-icon
			label-position="left"
			label-width="120px"
			size="mini"
			v-loading="loadings.main"
			@submit.native.prevent
		>
			<div class="col-md-4">
				<el-form-item label="旧密码" prop="password" :error="err.password">
					<el-input type="password" placeholder="请输入旧密码" v-model="form.password"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password_new" :error="err.password_new">
					<el-input type="password" placeholder="新密码" v-model="form.password_new"></el-input>
				</el-form-item>
				<el-form-item label="重新输入密码" prop="password_repeat">
					<el-input type="password" placeholder="重新输入密码" v-model="form.password_repeat"></el-input>
				</el-form-item>
				<el-button size="mini" type="primary" @click="onSubmit">确 定</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请输入密码"));
			} else {
				if (this.form.password !== "" && this.form.password == value) {
					callback(new Error("新密码不可和之前密码相同"));
				}
				if (this.form.password_repeat !== "") {
					this.$refs.editorForm.validateField("password_repeat");
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请再次输入密码"));
			} else if (value !== this.form.password_new) {
				callback(new Error("两次输入密码不一致!"));
			} else {
				callback();
			}
		};
		return {
			form: {
				password: "",
				password_new: "",
				password_repeat: "",
			},
			err: {
				password: "",
				password_new: "",
				password_repeat: "",
			},
			loadings: {
				main: false,
			},
			rules: {
				password: [
					{ required: true, message: "请输入密码", trigger: "blur" },
					{ min: 6, message: "长度在6个字符以上", trigger: "change" },
				],
				password_new: [
					{ validator: validatePass, trigger: "blur" },
					{ required: true, message: "请输入密码", trigger: "blur" },
					{ min: 6, message: "长度在6个字符以上", trigger: "change" },
				],
				password_repeat: [
					{ validator: validatePass2, trigger: "blur" },
					{ required: true, message: "请输入密码", trigger: "blur" },
				],
			},
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {
		onSubmit() {
			this.$refs.editorForm.validate(valid => {
				if (valid) {
					this._doSubmit();
				} else {
					return false;
				}
			});
		},
		_doSubmit() {
			this.loadings.main = true;
			let data = {
				password: this.form.password,
				password_new: this.form.password_new,
			};
      console.log(data)
			this.$axios
				.post("/admin/do_change_pwd/", data)
				.then(json => {
					this.$message({
						type: "success",
						message: "修改成功!",
					});
					this.loadings.main = false;
					this.$router.replace({
						name: "Index",
						params: {},
					});
				})
				.catch(json => {
					this.loadings.main = false;
					if (json.data.field && json.data.msg) {
						this.err[json.data.field] = json.data.msg;
					}

					this.$message({
						message: json.data.msg,
						type: "error",
					});
				});
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
